<script setup lang="ts">
import { ROUTES } from '~/common/routes'
import { useTranslation } from '~/composables'

const { withLocale } = useTranslation()
</script>

<template>
  <section id="project" class="relative overflow-hidden py-16">
    <svg class="absolute top-0 left-0 opacity-10" width="200" height="200" fill="none" viewBox="0 0 200 200">
      <defs>
        <pattern id="d3eb07ae-5182-43e6-857d-35c643af9034" x="0" y="0" width="20" height="20" patternUnits="userSpaceOnUse">
          <circle class="text-primary-500" fill="currentColor" cx="3" cy="3" r="3" />
        </pattern>
      </defs>
      <rect width="200" height="200" fill="url(#d3eb07ae-5182-43e6-857d-35c643af9034)" />
    </svg>
    <div class="max-w-7xl mx-auto px-4">
      <div class="text-center max-w-xl mx-auto">
        <span class="font-semibold text-accent-500 tracking-wider uppercase">
          {{ $t('pages.index.project.suptitle') }}
        </span>
        <h2 class="max-w-lg mx-auto font-heading mt-1 mb-5 text-2xl font-semibold text-gray-900 md:text-3xl">
          {{ $t('pages.index.project.title') }}
        </h2>
        <p class="max-w-xl mb-12 mx-auto text-gray-500 md:text-justify">
          <i18n-t keypath="pages.index.project.content" tag="span" for="pages.index.project.link" scope="global">
            <router-link :to="withLocale(ROUTES.ROOMS).value" class="underline">
              {{ $t('pages.index.project.link') }}
            </router-link>
          </i18n-t>
        </p>
        <router-link :to="withLocale(ROUTES.HOTEL).value"
                     class="inline-block w-full bg-gray-900 border border-transparent rounded-md py-3 px-8 font-medium text-white hover:bg-gray-800 sm:w-auto"
        >
          {{ $t('pages.index.project.learn-more') }}
        </router-link>
      </div>
    </div>
  </section>
</template>
